import { useEffect, useState } from "react";
import { useRemote } from "../../../Utils/Utils";
import PageGridItem from "../../Shared/Page/PageGridItem";
import ExpandingDropzone from "../../../components/Dropzone/ExpandingDropzone";
import "./AdminCompanyDisclaimersPage.scss";


const AdminCompanyDisclaimersPage = () => {
	const remote = useRemote();
	const [uploadingDisclaimer, setUploadingDisclaimer] = useState(false);
	const [disclaimerFile, setDisclaimerFile] = useState(null);

	useEffect(() => {
		remote
			.get("/setup/disclaimer.pdf", { rawResponse: true })
			.then((response) => response.arrayBuffer())
			.then((arrayBuffer) => setDisclaimerFile(btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)))));
	}, []);

	async function onDrop(files) {
		if (files && files.length > 0) {
			setUploadingDisclaimer(true);
			setDisclaimerFile(null);

			files[0].arrayBuffer().then((arrayBuffer) => {
				const uInt8Array = new Uint8Array(arrayBuffer);
				setUploadingDisclaimer(false);
				setDisclaimerFile(btoa(String.fromCharCode(...uInt8Array)));
				remote.post("/setup/disclaimer", { file: [...uInt8Array] });
			});
		}
	}


	return (
		<PageGridItem colSpan="7">
			<div className="upload-section">
				<ExpandingDropzone expandedZoneClass="" smallZoneClass="" onDrop={onDrop} uploading={uploadingDisclaimer} showUploadingSpinner={true} uploadingMessage="Uploading..." >
					<div className="uploaded-file-container">
						{disclaimerFile && (
							<iframe title="uploaded file" src={`data:application/pdf;base64,${disclaimerFile}`} style={{ width: "100%", height: "100%" }}></iframe>
						)}
					</div>
				</ExpandingDropzone>
			</div>
		</PageGridItem>
	);
}

export default AdminCompanyDisclaimersPage;
